<!--
- 手机用户信息（手机端）
- author: lzp
- greatTime: 2019-11-06
-->
<template lang="html">
  <div class="collect-info-container" :style="{'height': window_height+'px'}">
    <Form ref="formInline" :model="params" label-position="left">
      <FormItem class="required" label="姓名" prop="name">
        <Input type="text" v-model="params.name" autocomplete="off" placeholder="请输入姓名"></Input>
      </FormItem>
      <FormItem class="required" label="公司" prop="comp_name">
        <Input type="text" v-model="params.comp_name" autocomplete="off" placeholder="请输入公司名称"></Input>
      </FormItem>
      <FormItem class="required" label="职位" prop="title">
        <Input type="text" v-model="params.title" autocomplete="off" placeholder="请输入职位"></Input>
      </FormItem>
      <FormItem class="required" label="手机号" prop="user">
        <Input type="text" placeholder="请输入正确的手机号" :value="user.mobile" disabled></Input>
      </FormItem>
      <FormItem label="微信号" prop="weixin">
        <Input type="text" v-model="params.weixin" autocomplete="off" placeholder="请输入微信号" ></Input>
      </FormItem>
      <FormItem label="邮箱">
        <Input type="text" v-model="params.email" autocomplete="off" placeholder="请输入邮箱"></Input>
      </FormItem>
    </Form>
    <div class="button" @click="submit">
      确认
    </div>
    <div class="message-valid" v-show="show_req">
      {{req_text}}
    </div>
  </div>
</template>

<script>
import { updateUserInfo, createThemeTypeOrder, receiveVipGive } from '../service'
import { user_mixin } from 'mobile/js/user_mixin'
export default {
  mixins: [user_mixin],
  data() {
    return {
      params: {
        user_key: this.$store.state.user_key,
        name: '',
        title: '',
        comp_name: '',
        weixin: '',
        email: ''
      },
      show_req: false,
      req_text: ''
    }
  },
  computed: {
    window_height() {
      return document.documentElement.clientHeight
    }
  },
  methods: {
    async submit() {
      if (!this.params.name || !this.params.comp_name || !this.params.title) {
        this.req_text = '带*的选项为必填项，请完善信息'
        this.show_req = true
        setTimeout(() => { this.show_req = false }, 2000)
        return
      }
      let reg = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (this.params.email) {
        if (!(reg.test(this.params.email))) {
          this.req_text = '邮箱格式不正确'
          this.show_req = true
          setTimeout(() => { this.show_req = false }, 2000)
          return
        }
      }
      if (!this.$route.query.p) {
        let res = await updateUserInfo(this.params, (error) => { this.$Message.error('提交失败!') })
        if(res.status == 'success') {
          this.user.name = this.params.name
          this.user.title = this.params.title
          this.user.compName = this.params.comp_name
          this.user.email = this.params.email
          this.user.weixin = this.params.weixin
          localStorage.user = JSON.stringify(this.user)
          this.$store.commit('updateUser', this.user)
          if ('theme_type_id' in this.$route.query) {
            let res = await createThemeTypeOrder({
              user_key: this.$store.state.user_key,
              theme_type_id: this.$route.query.theme_type_id
            })
            if (res.status == 'success') {
              this.$router.push({name: 'MBuyInfo',params: {order_uid: res.order_uid, type: this.$route.query.type}, query: {url: this.$route.query.url}})
            } else {
              this.$Message.error(res.message)
            }
          }
        } else {
          this.$Message.error(res.message)
        }
      } else {
        this.params.id = this.$route.query.p
        let res = await receiveVipGive(this.params, (error) => { this.$Message.error('提交失败!') })
        if(res.status == 'success') {
          this.user.name = this.params.name
          this.user.title = this.params.title
          this.user.compName = this.params.comp_name
          this.user.email = this.params.email
          this.user.weixin = this.params.weixin
          localStorage.user = JSON.stringify(this.user)
          this.$store.commit('updateUser', this.user)
          this.$router.push({name: 'MExperienceSuccess', query: { p: this.$route.query.p, sign: this.$route.query.sign}})
        } else {
          this.$Message.error(res.message)
        }
      }
    }
  },
  created() {
    if(this.user.name && this.$route.query.p) {
      this.params.name = this.user.name
      this.params.title = this.user.title
      this.params.comp_name = this.user.compName
      this.params.email = this.user.email
      this.params.weixin = this.user.weixin
    }
  }
}
</script>

<style lang="stylus" scoped>
.collect-info-container
  padding-top: .2rem;
  background-color: #F8F8F8;
  form
    background-color: #ffffff;
    padding: 0 .3rem;
    >>>.ivu-form-item
      margin-bottom: 0;
      display: flex;
      align-items: center;
      height: 1rem;
      .ivu-form-item-label
        width: 1.4rem;
        font-size: .28rem;
        color: #666666
      &.required
        .ivu-form-item-label:before
          content: '*';
          color: #FC3B3B;
      input
        border: 0;
        font-size: .28rem;
        color: #333333
        &:focus
          box-shadow: none
        &.ivu-input-disabled
          background-color: #ffffff
        &:placeholder
          color: #999999;
          font-size: .28rem
    >>>.ivu-form-item+.ivu-form-item
      border-top: 1px solid #DFDFDF;
  .button
    margin: .6rem auto 0;
    width: 6rem;
    height: .9rem;
    color: #ffffff;
    font-size: .36rem;
    text-align: center;
    line-height: .9rem;
    border-radius: .45rem;
    background: rgba(250, 122, 80, 1)
  .message-valid
    width: 5.2rem;
    text-align: center;
    padding: .15rem .26rem;
    background: #000000;
    opacity:0.5;
    border-radius:.06rem;
    position: absolute;
    top: 4rem;
    left: 50%;
    transform: translateX(-2.6rem);
    margin: 0 auto;
    color: #ffffff;
    font-size: .28rem;
</style>
